import { Link } from "react-router-dom";

const Sidebar = ({
  isOpen,
  close,
}) => {

  return (
    <div
      className={`fixed inset-0 z-[9999] transition-all duration-500 ${isOpen
          ? "visible opacity-100"
          : "invisible opacity-0"
        }`}
    >

      {/* BACKDROP */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={close}
      ></div>

      {/* SIDEBAR PANEL */}
      <div
        className={`absolute top-0 right-0 h-full w-[90%] sm:w-[420px] bg-white shadow-2xl overflow-y-auto transition-all duration-500 ${isOpen
            ? "translate-x-0"
            : "translate-x-full"
          }`}
      >

        {/* TOP */}
        <div className="sticky top-0 z-20 bg-[#072F5F] px-6 py-5 flex items-center justify-between shadow-lg">

          <h2 className="text-2xl font-extrabold text-white tracking-wide">

            MENU

          </h2>

          <button
            className="w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 text-white text-xl flex items-center justify-center transition-all duration-300"
            onClick={close}
          >

            ✕

          </button>

        </div>

        {/* MENU */}
        <div className="p-6">

          <ul className="space-y-3">

            {/* ITEM */}
            <li>
              <Link
                to="/"
                onClick={close}
                className="block bg-[#f7f9fc] hover:bg-[#0B4F9C] hover:text-white text-[#072F5F] font-semibold px-5 py-4 rounded-2xl transition-all duration-300"
              >

                HOME

              </Link>
            </li>


            {/* ABOUT */}
            <li>
              <Link
                to="/about"
                onClick={close}
                className="block bg-[#f7f9fc] hover:bg-[#0B4F9C] hover:text-white text-[#072F5F] font-semibold px-5 py-4 rounded-2xl transition-all duration-300"
              >

                ABOUT

              </Link>
            </li>


            {/* SIMPLE ITEMS */}
            {[
              [
                "/admission",
                "ADMISSION",
              ],

              [
                "/archives",
                "AECHIVES",
              ],

               [
                "/academics",
                "ACADEMICS",
              ],

              [
                "/clubs",
                 "CLUBS"
              ],

              [
                "/events",
                "EVENTS",
              ],

              [
                "/sports",
                 "SPORTS"
              ],

              [
                "/gallery",
                "GALLERY",
              ],

              [
                "/documents",
                "HOMEWORKS",
              ],

              [
                "/cbse-documents",
                "CBSE DOCUMENT",
              ],

              [
                "/life",
                "LIFE AT SCHOOL",
              ],
             
              [
                "/news",
                "NEWS",
              ],

              [
                "/contact",
                "CONTACT",
              ],

              [
                "/student-tc",
                "STUDENT TC",
              ],

              [
                "/virtual-tour",
                "VIRTUAL TOUR",
              ],
              
              [
                "/online-registration",
                "ONLINE REGISTRATION",
              ],
              
            ].map(
              (
                item,
                index
              ) => (
                <li key={index}>

                  <Link
                    to={item[0]}
                    onClick={
                      close
                    }
                    className="block bg-[#f7f9fc] hover:bg-[#0B4F9C] hover:text-white text-[#072F5F] font-semibold px-5 py-4 rounded-2xl transition-all duration-300"
                  >

                    {item[1]}

                  </Link>

                </li>
              )
            )}

          </ul>

          {/* BOTTOM */}
          <div className="mt-10">

            <Link
              to="/admin/login"
              onClick={close}
              className="block w-full text-center bg-[#D4A017] hover:bg-yellow-600 text-white font-bold py-4 rounded-2xl shadow-lg transition-all duration-300"
            >

              ADMIN LOGIN

            </Link>

          </div>

        </div>

      </div>

    </div>
  );
};

export default Sidebar;